import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../../../CommonComponents/Dropdown';
import { OrionAssetClassCell, AdvizrAssetClassCell, OrdinalText } from '../styles';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  DropdownTrigger,
} from '../../../OrionOnboardingStyles';

const TableView = ({ assetClassMappings, handleAssetClassMappingChange, assetClasses }) => (
  <Table>
    <TableHeader>
      <TableRow>
        <OrionAssetClassCell>ORION ASSET CLASS</OrionAssetClassCell>
        <AdvizrAssetClassCell>ORION PLANNING</AdvizrAssetClassCell>
      </TableRow>
    </TableHeader>

    <TableBody>
      {assetClassMappings.map((assetClassMapping, i) => {
        const currentAssetClass = assetClasses.find(
          ({ value }) => assetClassMapping.InternalAssetClass === value,
        );

        return (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={i}>
            <OrionAssetClassCell>
              <OrdinalText>{i + 1}</OrdinalText>
              <span>{assetClassMapping.ExternalAssetClassName}</span>
            </OrionAssetClassCell>

            <AdvizrAssetClassCell>
              <Dropdown
                value={currentAssetClass && currentAssetClass.value}
                items={assetClasses}
                onChange={updatedAssetClassMapping =>
                  handleAssetClassMappingChange(i, updatedAssetClassMapping)
                }
              >
                <DropdownTrigger appendIcon="fa fa-angle-down">
                  {currentAssetClass && currentAssetClass.label}
                </DropdownTrigger>
              </Dropdown>
            </AdvizrAssetClassCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);

TableView.propTypes = {
  assetClassMappings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleAssetClassMappingChange: PropTypes.func.isRequired,
  assetClasses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default TableView;
